import React, { Component } from "react";
import Image from "../../../../../../components/ZUILib/Image";
import commonUtil from "../../../../../../utils/commonUtil";

import * as defaultConst from "../../../../../../utils/clientConstant";

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];

export default class Template1 extends Component {
  render() {
    const { giftDetail, eventContractInfo } = this.props;
    const giftSection = "ComprasPersonales";
    const giftImageSrc = [
      {
        media: "(max-width: 465px)",
        srcSet: giftDetail.imageURL,
      },
    ];
    const giftImageAttribute = {
      className: "thumb",
      id: "img1",
      alt: "Liverpool",
      src: giftDetail.imageURL,
      altImg: giftDetail?.altImageUrl || commonUtil.getAssetURL() + "/images/guest/no-image.png",
    };
     const giftPrice = commonUtil.getCurrency(giftDetail.price);
        const [giftPriceWhole, giftPricecents] = giftPrice?.split('.') ?? ['', ''];
      const giftPriceFormatted = (
        <>
        <span className="amount">{giftPriceWhole}</span><sup className="decimal">{giftPricecents}</sup>
        </>
      );
    if (commonUtil.isEmpty(giftDetail) || giftDetail === undefined) {
      // TODO: || giftDetail.purchaseInfo === undefined
      return null;
    }
    return (
      <React.Fragment>
        <tr>
          <td>
            <Image imageAttr={giftImageAttribute} _imgsrc={giftImageSrc} />
          </td>
          <td>
            <div className="headTitle">{giftDetail.displayName}</div>
            <div>
               <strong className="skuColor">{commonUtil.getLabel(this.props.lables.EventAdminPage,"adminpage.comparas.sku.by.label")}:</strong> <span className="text-muted">{giftDetail.skuId}</span>
            </div>
            {giftDetail.actionType !== "purchase" ? (
              <div className="price">{giftPriceFormatted}</div>
            ) : (
              <div className="price">{giftPriceFormatted}</div>
            )}

            <div className="quantity">
              <strong className="color5C5C5C">{commonUtil.getLabel(
                this.props.lables.EventAdminPage,
                "adminpage.comparas.qty.label"
              )}</strong>
              : <span className="cantidadColor">{giftDetail.quantity}</span>
            </div>
                {
                  (
                    <React.Fragment>
                      {this.props.compareEventStatus(giftDetail.deliveryStatus, "store.delivery.message") ? (
                        <div className="tag statusDeliverToStore">
                          {/* Entregado en tienda */}
                          <span className="icon-circle"></span>
                          {commonUtil.getLabel(this.props.lables.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                        </div>
                      ) :
                        this.props.compareEventStatus(giftDetail.deliveryStatus, "electronic.delivery.message") || this.props.compareEventStatus(giftDetail.deliveryStatus, "physical.delivery.message") ? (
                          <div className="tag statusDeliverToStoreGreen">
                            {commonUtil.getLabel(this.props.lables.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                          </div>
                        ) : giftDetail.deliveryStatus ?(
                           <div className={`tag ${giftDetail.actionType === "returnReinvested" ? "tag-reinvested" : "tag-return"}`}>
                            <span className="icon-circle"></span>
                            {commonUtil.getLabel(this.props.lables.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                          </div>
                        ): null}
                    </React.Fragment>
                  )
                  // modalButton
                }


            {(eventContractInfo && eventContractInfo.bonus > 0) &&(this.props.eventType !== defaultConst.eventType.Others) ? (
              <div className="extra">
                {commonUtil.getLabel(
                  this.props.lables.EventAdminPage,
                  "adminpage.comparas.bonus.label"
                )}
                &nbsp;&nbsp;&nbsp;
                  {giftDetail.bonusInfo === "true" ? (
                    <i className="icon-check confirmCheck" aria-hidden="true" />
                  ) : (
                    'x'
                  )}{" "}
              </div>
            ) : (
              ""
            )}
             {(eventContractInfo && eventContractInfo.bonus > 0) && this.props.eventType === defaultConst.eventType.Others &&
              <div className="extra">
                {commonUtil.getLabel(
                  this.props.lables.EventAdminPage,
                  "adminpage.comparas.bonus.label"
                )}
                &nbsp;&nbsp;
                  x
              </div>
              }
          </td>
          <td
            onClick={() =>
              this.props.selectedProductForPreview(giftDetail, giftSection)
            }
          >
            <a className="productDetail">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
                <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
              </svg>
            </a>
          </td>
        </tr>
      </React.Fragment>
    );
  }
}
